import React, { Component, PropTypes } from 'react';

let $ = window.jQuery;

export default class DateField extends Component {
    static propTypes = {
        val: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        help: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired
    };

    state = {
        val : ''
    };

    handleChange = (e) => {
        this.setState({val : e.target.value});
    };

    componentDidMount() {
        $('#'+this.props.id).datepicker({
            orientation: 'bottom',
            autoclose: true,
            format: 'MM dd, yyyy',
            startDate: this.props.startDate ? this.props.startDate : '-150y',
            endDate: this.props.endDate ? this.props.endDate : '+150y',
            todayHighlight: true
        }).on('changeDate', (e) => {
            this.props.onChange(e);
        });

        this.setState({
            val: this.props.val
        }, () => {
            $('#'+this.props.id).datepicker('update', this.state.val)
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            val: nextProps.val
        }, () => {
            $('#'+this.props.id).datepicker('update', this.state.val)
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }

    render() {
        let className = this.state.val ? 'form-control date-picker edited' : 'form-control date-picker';
        let helperClass = this.state.val ? 'help-block hidden' : 'help-block';
        return (
            <div className="form-group form-md-line-input">
                <input type="text" className={className} id={this.props.id}
                       name={this.props.id} onChange={this.handleChange}
                       value={this.state.val}
                       readOnly={this.props.readonly} />

                <label htmlFor={this.props.id}>{this.props.label} </label>
                <span className={helperClass}>{this.props.help}</span>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/commons/Inputs/DateField.js
 **/